angular.module('ApptBookApp').filter('employee', function () {
    return function (employee) {
        if (!isObject(employee)) {
            return '';
        };

        return employee.code + ': ' + employee.lastName + ', ' + employee.firstName;
    };
});